__cw__define(['cookies'], function (cookies) {
  window.routersSetup = window.routersSetup || [];
  var A = 0;
  var B = 1;
  function init() {
    window.routersSetup.forEach(function (router) {
      if (router.type == 'ABOnPercentage') {
        ABPercentage(router.ids, router.value, router.useABCookie);
      }
      if (router.type == 'ABParameter') {
        ABParameter(router.ids, router.typeParam, router.paramToFind, router.value);
      }
      if (router.type == 'ABAdvisorPersonalizedLink') {
        ABAdvisorPersonalizedLink(router.ids);
      }
    });
  }
  function ABPercentage(ids, percentage, useABCookie) {
    if (document.querySelectorAll(".option-" + ids[A]).length > 0 && document.querySelectorAll(".option-" + ids[B]).length > 0) {
      var randomNumber = Math.random() * 100;
      var configAB;
      var AOrB = 'A';
      if (useABCookie == 'True') {
        configAB = cookies.get('versionABTest');
      }
      if (configAB && configAB != '') {
        AOrB = configAB;
      } else {
        AOrB = randomNumber <= percentage ? 'A' : 'B';
      }
      ABSetup(ids, AOrB, useABCookie == 'True');
    }
  }
  function ABParameter(ids, typeParam, paramToFind, value) {
    var A = 0;
    var B = 1;
    var AOrB = 'A';
    if (typeParam == 'query-string') {
      var urlParts = window.location.href.split(/[?#]/)[1];
      if (urlParts && urlParts.length > 1) {
        var params = urlParts.split('&');
        if (paramFound(params, paramToFind, value)) {
          AOrB = 'B';
        }
      }
    }
    if (typeParam == 'cookies') {
      var cookieValue = getCookie(paramToFind);
      if (cookieValue && (value == '' || value == cookieValue)) {
        AOrB = 'B';
      }
    }
    if (typeParam == 'local-storages') {
      var storageValue = localStorage.getItem(paramToFind);
      if (storageValue && (value == '' || value == storageValue)) {
        AOrB = 'B';
      }
    }
    if (typeParam == 'session-storages') {
      var _storageValue = sessionStorage.getItem(paramToFind);
      if (_storageValue && (value == '' || value == _storageValue)) {
        AOrB = 'B';
      }
    }
    ABSetup(ids, AOrB);
  }
  function ABAdvisorPersonalizedLink(ids) {
    var A = 0;
    var B = 1;
    var urlParts = window.location.href.split(/[?#]/)[1];
    var codeUidAgent = cookies.get('codeUidAgent') || 'invalid';
    var AOrB = 'A';
    if (urlParts && urlParts.length > 1) {
      var params = urlParts.split('&');
      if (paramFound(params, 'uid', codeUidAgent)) {
        AOrB = 'B';
      }
    }
    ABSetup(ids, AOrB);
  }
  function paramFound(params, paramToFind, value) {
    for (var i = 0; i < params.length; i++) {
      var param = params[i].split('=');
      if (param[0] == paramToFind) {
        return !value || param[1] == value;
      }
    }
    return false;
  }
  function ABSetup(ids, AOrB, useABCookie) {
    if (useABCookie === void 0) {
      useABCookie = false;
    }
    document.querySelectorAll(".option-" + ids[A]).forEach(function (o) {
      if (AOrB == 'A') {
        o.classList.remove('display-none');
        if (useABCookie) {
          cookies.set('versionABTest', 'A', 1);
        }
      } else {
        o.remove();
      }
    });
    document.querySelectorAll(".option-" + ids[B]).forEach(function (o) {
      if (AOrB == 'B') {
        o.classList.remove('display-none');
        if (useABCookie) {
          cookies.set('versionABTest', 'B', 1);
        }
      } else {
        o.remove();
      }
    });
  }
  function getCookie(cookieName) {
    var name = cookieName + '=';
    var split = document.cookie.split(';');
    for (var i = 0; i < split.length; i++) {
      var _char = split[i];
      while (_char.charAt(0) == ' ') {
        _char = _char.substring(1);
      }
      if (_char.indexOf(name) == 0) {
        return _char.substring(name.length, _char.length);
      }
    }
    return '';
  }
  return {
    init: init
  };
});